module.exports = __webpack_public_path__ + "img/Reg-5-ScientificProg.2dc50e79.svg";